<template>
    <app-layout>
        <form @submit.prevent="storeCompany" class="h-full">
            <base-header :shadow="false" border border-bg-from="from-green-500" border-bg-to="to-teal-500">
                <div>
                    <div class="text-xl font-bold">
                    <span v-if="form.name">
                        {{ form.name }}
                    </span>
                        <element-placeholder width="w-96" class="block" v-else/>
                    </div>
                </div>

                <div class="flex items-center">
                    <default-button :href="route('companies.index')" color="gray" size="sm" class="mr-2">
                        {{ $t('form.cancel') }}
                    </default-button>
                    <default-button icon="save" size="sm" type="submit" :loading="form.processing">
                        {{ $t('form.submit') }}
                    </default-button>
                </div>
            </base-header>

            <base-content>
                <base-card>
                    <template #header>
                        {{ $t('general.company') }}
                    </template>
                    <template #body>
                        <div class="space-y-4">
                            <input-group v-model="form.name" name="name" :label="$t('general.name')" :form="form"
                                         required/>
                            <input-group v-model="form.address" name="address" :label="$t('location.address')"
                                         :form="form"/>

                            <div class="sm:grid sm:grid-cols-2 sm:gap-4">
                                <input-group v-model="form.postcode" name="postcode"
                                             :label="$t('location.postcode')" :form="form"/>
                                <input-group v-model="form.city" name="city" :label="$t('location.city')"
                                             :form="form"/>
                            </div>

                            <input-group name="country" :label="$t('location.country')" :form="form">
                                <multiselect v-model="form.country" name="country" label="label" track-by="value"
                                             :options="countryOptions"/>
                            </input-group>
                        </div>
                    </template>
                </base-card>
            </base-content>
        </form>
    </app-layout>
</template>

<script>
export default {
    props: {
        company: Object,
    },

    data() {
        return {
            countryOptions: [
                {value: 'AT', label: this.$t('country.AT')},
                {value: 'DE', label: this.$t('country.DE')},
            ],

            form: this.$inertia.form({
                name: this.company?.name,
                address: this.company?.address,
                postcode: this.company?.postcode,
                city: this.company?.city,
                country: this.company?.country,
            }),
        };
    },

    created() {
        if (this.company) {
            this.form.country = this.countryOptions.find(country => country.value === this.form.country);
        }
    },

    methods: {
        storeCompany() {
            let transformed = this.form.transform(data => {
                return {
                    ...data,
                    country: data.country ? data.country.value : null,
                }
            })

            if (this.company) {
                transformed.put(route('companies.update', this.company.id));
            } else {
                transformed.post(route('companies.store'));
            }
        },
    },
};
</script>
